/* Auro & Co collection filters: multi-select within a group (OR), combined across groups (AND).
   Markup: sections/auro-collection-filters.liquid. Data: sections/auro-collection-data.liquid. Cards: assets/auro-cards.js. */
(function () {
  var root = document.querySelector('[data-af]');
  if (!root) return;
  var base = root.dataset.afBase;
  var sort = root.dataset.afSort || '';
  var totalAll = parseInt(root.dataset.afTotalAll, 10) || 0;
  var grid = document.getElementById('product-grid');
  var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var PAGE = 24;
  var shown = PAGE;
  var groupOf = {};
  var labelOf = {};
  var sel = {};
  var lastTag = null;
  var data = null;
  var loading = null;
  var serverHTML = grid ? grid.innerHTML : '';
  var startPage = new URLSearchParams(window.location.search).get('page');
  var moreBtn = null;
  var shownInit = 0;
  var wrap = root.closest('.shopify-section') || root;
  var sheet = root.querySelector('[data-af-sheet]');
  var sheetBtn = root.querySelector('[data-af-sheet-open]');
  var phone = window.matchMedia('(max-width: 749px)');

  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  $$('[data-af-group]', root).forEach(function (dd) {
    $$('[data-af-tag]', dd).forEach(function (a) {
      groupOf[a.dataset.afTag] = dd.dataset.afGroup;
      labelOf[a.dataset.afTag] = a.dataset.afLabel;
    });
  });

  function active() { return Object.keys(sel).some(function (g) { return sel[g].length; }); }
  function picked() { return Object.keys(sel).reduce(function (n, g) { return n + sel[g].length; }, 0); }

  function readUrl() {
    var n = parseInt(new URLSearchParams(window.location.search).get('afn'), 10);
    if (n > PAGE) shownInit = n;
    var p = new URLSearchParams(window.location.search).get('af');
    if (!p) return;
    p.split(';').forEach(function (part) {
      var bits = part.split(':');
      if (bits.length < 2) return;
      bits[1].split(',').forEach(function (t) {
        if (groupOf[t] === bits[0]) {
          sel[bits[0]] = sel[bits[0]] || [];
          if (sel[bits[0]].indexOf(t) < 0) { sel[bits[0]].push(t); lastTag = t; }
        }
      });
    });
  }
  function afParam() {
    return Object.keys(sel).filter(function (g) { return sel[g].length; }).map(function (g) { return g + ':' + sel[g].join(','); }).join(';');
  }
  function writeUrl() {
    var u = new URL(window.location.href);
    var v = afParam();
    if (v) u.searchParams.set('af', v); else u.searchParams.delete('af');
    if (v && shown > PAGE) u.searchParams.set('afn', shown); else u.searchParams.delete('afn');
    if (v) u.searchParams.delete('page');
    history.replaceState(null, '', u.toString());
  }

  function parse(html) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var s = d.querySelector('[data-acd]');
    if (!s) throw new Error('no data');
    return { pages: parseInt(s.dataset.pages, 10) || 1, items: JSON.parse(s.textContent) };
  }
  function fetchPage(u, i, tries) {
    tries = tries || 0;
    return fetch(u + '&page=' + i, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(parse)
      .catch(function (e) {
        if (tries >= 2) throw e;
        return new Promise(function (res) { setTimeout(res, 500 * (tries + 1)); }).then(function () { return fetchPage(u, i, tries + 1); });
      });
  }
  function prep(items) {
    items.forEach(function (p) { p.tagset = {}; (p.tg || []).forEach(function (t) { p.tagset[t] = true; }); });
    return items;
  }
  function load() {
    if (data) return Promise.resolve(data);
    if (loading) return loading;
    var u = base + '?section_id=auro-collection-data' + (sort ? '&sort_by=' + encodeURIComponent(sort) : '');
    var key = 'acd:' + u;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && cached.t > Date.now() - 600000) { data = prep(cached.items); return Promise.resolve(data); }
    } catch (e) {}
    /* Page 1 first (it says how many pages there are), then the rest 4 at a time, kept in collection order */
    loading = fetchPage(u, 1).then(function (first) {
      var byPage = [first.items];
      var todo = [];
      for (var i = 2; i <= first.pages; i++) todo.push(i);
      function worker() {
        var n = todo.shift();
        if (!n) return Promise.resolve();
        return fetchPage(u, n).then(function (r) { byPage[n - 1] = r.items; return worker(); });
      }
      return Promise.all([worker(), worker(), worker(), worker()]).then(function () {
        var items = [].concat.apply([], byPage.filter(Boolean));
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        data = prep(items);
        return data;
      });
    }).catch(function (e) { loading = null; throw e; });
    return loading;
  }
  function showError(msg) {
    var el = $('[data-af-error]', root);
    if (!el) {
      el = document.createElement('p');
      el.className = 'af-error';
      el.setAttribute('role', 'alert');
      el.setAttribute('data-af-error', '');
      $('[data-af-chips]', root).insertAdjacentElement('afterend', el);
    }
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function matches(p, skip) {
    for (var g in sel) {
      if (g === skip || !sel[g].length) continue;
      if (!sel[g].some(function (t) { return p.tagset[t]; })) return false;
    }
    return true;
  }

  /* Search box in long option lists: keeps options with a word starting with the typed text ("tea" finds Tealights, not Steamers) */
  function words(s) { return ' ' + String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function searchList(dd) {
    var inp = $('[data-af-search]', dd);
    if (!inp) return;
    var q = words(inp.value).trim();
    var any = false;
    $$('[data-af-tag]', dd).forEach(function (a) {
      var hit = !q || words(a.dataset.afLabel).indexOf(' ' + q) > -1;
      a.parentNode.classList.toggle('is-nomatch', !hit);
      if (hit && !a.parentNode.hidden) any = true;
    });
    var nm = $('[data-af-nomatch]', dd);
    if (nm) nm.hidden = any || !q;
  }

  function updateCounts() {
    if (!data) return;
    $$('[data-af-group]', root).forEach(function (dd) {
      var g = dd.dataset.afGroup;
      var pool = data.filter(function (p) { return matches(p, g); });
      $$('[data-af-tag]', dd).forEach(function (a) {
        var t = a.dataset.afTag;
        var n = pool.filter(function (p) { return p.tagset[t]; }).length;
        $('[data-af-num]', a).textContent = n;
        a.parentNode.hidden = n === 0 && !(sel[g] && sel[g].indexOf(t) > -1);
      });
      dd.hidden = !$$('[data-af-tag]', dd).some(function (a) { return !a.parentNode.hidden; }) && !(sel[g] && sel[g].length);
      searchList(dd);
    });
  }

  function updateUI(count) {
    $$('[data-af-group]', root).forEach(function (dd) {
      var g = dd.dataset.afGroup;
      var picked = sel[g] || [];
      $$('[data-af-tag]', dd).forEach(function (a) { a.setAttribute('aria-checked', String(picked.indexOf(a.dataset.afTag) > -1)); });
      $('[data-af-count]', dd).textContent = picked.length ? picked.length : '';
      dd.classList.toggle('is-active', picked.length > 0);
    });
    var all = picked();
    $$('[data-af-allcount]', root).forEach(function (s) { s.textContent = all ? all : ''; });
    if (sheetBtn) sheetBtn.classList.toggle('is-active', all > 0);
    var n = typeof count === 'number' ? count : totalAll;
    $$('[data-af-total]', root).forEach(function (s) { s.textContent = n; });
    $('[data-af-status-count]', root).textContent = n + (n === 1 ? ' product' : ' products');
    var chips = '';
    Object.keys(sel).forEach(function (g) {
      sel[g].forEach(function (t) {
        chips += '<button type="button" class="af-chip" data-af-chip="' + esc(t) + '" aria-label="Remove ' + esc(labelOf[t]) + '">' + esc(labelOf[t]) + '<span aria-hidden="true">&times;</span></button>';
      });
    });
    if (chips) chips += '<button type="button" class="af-clear" data-af-clear>Clear all</button>';
    $('[data-af-chips]', root).innerHTML = chips;
  }

  function srcset(u) {
    if (!u) return '';
    return [180, 280, 360, 533, 720].map(function (w) { return u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
  }
  /* Same layout as snippets/card-product.liquid */
  function card(p) {
    var u = esc(p.u);
    var sizes = '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw';
    var media = p.i
      ? '<img class="ac-card__img" src="' + esc(p.i) + '" srcset="' + esc(srcset(p.i)) + '" sizes="' + sizes + '" alt="' + esc(p.alt) + '" loading="lazy">' +
        (p.i2 ? '<img class="ac-card__img ac-card__img--hover" src="' + esc(p.i2) + '" srcset="' + esc(srcset(p.i2)) + '" sizes="' + sizes + '" alt="" loading="lazy">' : '')
      : '';
    var badge = '';
    if (!p.a) badge = '<span class="ac-card__badge ac-card__badge--sold">Sold out</span>';
    else if (p.cp > p.p) badge = '<span class="ac-card__badge ac-card__badge--sale">Save ' + money.format((p.cp - p.p) / 100).replace(/\.00$/, '') + '</span>';
    var ls = p.ls ? '<span class="ac-card__ls" style="position:absolute;left:.2rem;bottom:.8rem;z-index:1;line-height:0;"><span class="badge badge--limited-stock" style="background-color:#8c3b4a;color:#ffffff;border-color:#8c3b4a;margin-left:0.6rem;white-space:nowrap;">Limited stock</span></span>' : '';
    var price = (p.pv ? 'From ' : '') + money.format(p.p / 100) + (p.cp > p.p ? '<s class="ac-card__was">' + money.format(p.cp / 100) + '</s>' : '');
    var actions;
    if (!p.a) actions = '<button type="button" class="ac-add" disabled>Sold out</button>';
    else if (p.m) actions = '<button type="button" class="ac-add" data-ac-qv aria-haspopup="dialog">Choose options</button>';
    else actions = '<button type="button" class="ac-add" data-ac-add aria-label="Add ' + esc(p.t) + ' to basket">Add to basket</button>' +
      '<div class="ac-stepper" data-ac-stepper hidden><button type="button" data-ac-minus aria-label="Remove one ' + esc(p.t) + '">&minus;</button><span data-ac-qty aria-live="polite">0</span><button type="button" data-ac-plus aria-label="Add one more ' + esc(p.t) + '">+</button></div>';
    return '<li class="grid__item"><div class="ac-card' + (p.a ? '' : ' is-sold-out') + '" data-ac-card data-product-url="' + u + '" data-variant-id="' + p.v + '" data-line-key="">' +
      '<a href="' + u + '" class="ac-card__media" style="aspect-ratio: 1 / 1;" tabindex="-1" aria-hidden="true">' + media + '<span class="ac-card__tick" aria-hidden="true">&#10003;</span>' + badge + ls + '</a>' +
      '<div class="ac-card__body"><h3 class="ac-card__title"><a href="' + u + '">' + esc(p.t) + '</a></h3>' + (p.ls ? '<span class="visually-hidden">Limited stock</span>' : '') +
      '<div class="ac-card__meta"><span class="ac-card__price">' + price + '</span><button type="button" class="ac-card__link" data-ac-qv aria-haspopup="dialog">Details</button></div></div>' +
      '<div class="ac-card__actions">' + actions + '</div></div></li>';
  }

  /* Page links and the "Show more" button of the unfiltered list (sections/auro-collection-ux.liquid) */
  function setPagination(show) {
    $$('.pagination-wrapper, .pagination, [data-ac-paged]').forEach(function (el) { el.style.display = show ? '' : 'none'; });
  }

  function emptyHTML() {
    var undo = lastTag && groupOf[lastTag] && (sel[groupOf[lastTag]] || []).indexOf(lastTag) > -1
      ? '<button type="button" class="af-more" data-af-chip="' + esc(lastTag) + '">Remove &ldquo;' + esc(labelOf[lastTag]) + '&rdquo;</button>'
      : '';
    return '<li class="af-empty"><p>No products match all of these filters.</p><div class="af-empty__actions">' + undo +
      '<button type="button" class="af-done" data-af-clear>Clear all filters</button></div></li>';
  }

  function render() {
    if (!grid) return;
    if (moreBtn) { moreBtn.remove(); moreBtn = null; }
    if (!active()) {
      if (startPage && startPage !== '1') { window.location.href = base + (sort ? '?sort_by=' + encodeURIComponent(sort) : ''); return; }
      grid.innerHTML = serverHTML;
      setPagination(true);
      updateUI(totalAll);
      document.dispatchEvent(new CustomEvent('af:reset'));
      if (window.AuroCards) window.AuroCards.sync();
      return;
    }
    var list = data.filter(function (p) { return matches(p, null); });
    grid.innerHTML = list.length ? list.slice(0, shown).map(card).join('') : emptyHTML();
    setPagination(false);
    if (list.length > shown) {
      moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'af-more';
      moreBtn.textContent = 'Show more (' + (list.length - shown) + ' more)';
      moreBtn.addEventListener('click', function () { var from = shown; shown += PAGE; writeUrl(); render(); var a = grid.children[from] && grid.children[from].querySelector('.ac-card__title a'); if (a) a.focus(); });
      grid.parentNode.insertBefore(moreBtn, grid.nextSibling);
    }
    updateUI(list.length);
    if (window.AuroCards) window.AuroCards.sync();
  }

  /* Bring the top of the results into view under the sticky bar, only when it is above the screen */
  function toGrid() {
    if (!grid) return;
    var y = grid.getBoundingClientRect().top + window.scrollY - stickTop() - wrap.offsetHeight - 12;
    if (window.scrollY > y) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  function apply(scrollUp) {
    showError('');
    shown = shownInit || PAGE;
    shownInit = 0;
    writeUrl();
    if (!active()) { updateCounts(); render(); return; }
    updateUI();
    $$('[data-af-total]', root).forEach(function (el) { el.textContent = '…'; });
    document.documentElement.classList.add('af-loading');
    load()
      .then(function () { updateCounts(); render(); if (scrollUp) toGrid(); })
      .catch(function () {
        showError('Filters could not load just now. Please try again.');
        if (window.AuroCards) window.AuroCards.sync();
      })
      .finally(function () { document.documentElement.classList.remove('af-loading'); });
  }

  function closeAll(except) { $$('[data-af-dd]', root).forEach(function (dd) { if (dd !== except) dd.open = false; }); }

  function isSheetOpen() { return root.classList.contains('is-sheet-open'); }
  function lock() {
    var anyOpen = $$('[data-af-dd]', root).some(function (d) { return d.open; });
    document.documentElement.classList.toggle('af-lock', phone.matches && (isSheetOpen() || anyOpen));
  }
  function openSheet() {
    if (!sheet) return;
    closeAll(null);
    root.classList.add('is-sheet-open');
    if (sheetBtn) sheetBtn.setAttribute('aria-expanded', 'true');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    lock();
    load().then(updateCounts).catch(function () {});
    var x = $('.af-sheet__head .af-close', sheet);
    if (x) x.focus({ preventScroll: true });
  }
  function closeSheet(goToGrid) {
    if (!isSheetOpen()) return;
    root.classList.remove('is-sheet-open');
    closeAll(null);
    if (sheetBtn) sheetBtn.setAttribute('aria-expanded', 'false');
    sheet.removeAttribute('role');
    sheet.removeAttribute('aria-modal');
    lock();
    if (sheetBtn) sheetBtn.focus({ preventScroll: true });
    if (goToGrid) toGrid();
  }

  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-af-sheet-open]')) { openSheet(); return; }
    var opt = t.closest('[data-af-tag]');
    if (opt) {
      e.preventDefault();
      var tag = opt.dataset.afTag;
      var g = groupOf[tag];
      sel[g] = sel[g] || [];
      var i = sel[g].indexOf(tag);
      if (i > -1) sel[g].splice(i, 1); else { sel[g].push(tag); lastTag = tag; }
      apply(false);
      return;
    }
    if (t.closest('[data-af-reset-group]')) {
      var dd = t.closest('[data-af-group]');
      sel[dd.dataset.afGroup] = [];
      apply(false);
      return;
    }
    var chip = t.closest('[data-af-chip]');
    if (chip) {
      var ct = chip.dataset.afChip;
      var cg = groupOf[ct];
      sel[cg] = (sel[cg] || []).filter(function (x) { return x !== ct; });
      apply(false);
      return;
    }
    if (t.closest('[data-af-clear]')) { sel = {}; apply(false); return; }
    var sl = t.closest('[data-af-sort-link]');
    if (sl && active()) {
      e.preventDefault();
      window.location.href = sl.getAttribute('href') + '&af=' + encodeURIComponent(afParam());
      return;
    }
    var sc = t.closest('[data-af-sheet-close]');
    if (sc) { closeSheet(sc.hasAttribute('data-af-to-grid')); return; }
    if (t.closest('[data-af-close]')) {
      var d = t.closest('[data-af-dd]');
      if (d) d.open = false;
      if (active() && t.closest('.af-done')) toGrid();
    }
  }
  root.addEventListener('click', onClick);
  /* The "nothing matches" buttons sit in the product grid */
  if (grid) grid.addEventListener('click', function (e) { if (e.target.closest('[data-af-chip], [data-af-clear]')) onClick(e); });

  root.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-af-search]')) return;
    searchList(e.target.closest('[data-af-group]'));
  });

  $$('[data-af-dd]', root).forEach(function (dd) {
    dd.addEventListener('toggle', function () {
      lock();
      var inp = $('[data-af-search]', dd);
      if (!dd.open) {
        if (inp && inp.value) { inp.value = ''; searchList(dd); }
        return;
      }
      closeAll(dd);
      var pn = dd.querySelector('.af-panel');
      if (pn) { pn.classList.remove('is-flip'); if (pn.getBoundingClientRect().right > document.documentElement.clientWidth - 8) pn.classList.add('is-flip'); }
      /* Ready to type on a computer; on phones the keyboard only opens when the box is tapped */
      if (inp && window.matchMedia('(hover: hover) and (pointer: fine)').matches) inp.focus({ preventScroll: true });
      if (dd.dataset.afGroup) load().then(updateCounts).catch(function () {});
    });
  });
  document.addEventListener('click', function (e) {
    $$('[data-af-dd]', root).forEach(function (dd) {
      if (!dd.open) return;
      var panel = dd.querySelector('.af-panel');
      var sum = dd.querySelector('summary');
      if (!panel.contains(e.target) && !sum.contains(e.target)) dd.open = false;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = $$('[data-af-dd]', root).filter(function (d) { return d.open; })[0];
    if (open && isSheetOpen() && sheet.contains(open)) { open.open = false; open.querySelector('summary').focus(); return; }
    if (isSheetOpen()) { closeSheet(false); return; }
    closeAll(null);
    if (open) open.querySelector('summary').focus();
  });
  root.addEventListener('keydown', function (e) {
    var opt = e.target.closest && e.target.closest('[data-af-tag]');
    if (opt && (e.key === ' ' || e.key === 'Spacebar')) { e.preventDefault(); opt.click(); }
    /* Enter in the search box ticks the first option still shown */
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-af-search]')) {
      e.preventDefault();
      var first = $$('[data-af-tag]', e.target.closest('[data-af-group]')).filter(function (a) { return !a.parentNode.hidden && !a.parentNode.classList.contains('is-nomatch'); })[0];
      if (first) first.click();
    }
  });
  /* Start loading as soon as a shopper reaches for a filter */
  $$('[data-af-dd] > summary, [data-af-sheet-open]', root).forEach(function (sm) {
    ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) { sm.addEventListener(ev, function () { load().catch(function () {}); }, { once: true, passive: true }); });
  });
  if (phone.addEventListener) phone.addEventListener('change', function () { if (!phone.matches) closeSheet(false); lock(); });

  /* Sticky bar: sits under the header while the header shows (it hides on scroll down), and fades out once the
     products have scrolled past, so it never covers the story and questions below them */
  var header = document.querySelector('.section-header');
  var gridBox = document.getElementById('ProductGridContainer') || grid;
  function stickTop() { return header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0; }
  var ticking = false;
  function stick() {
    ticking = false;
    var top = stickTop();
    wrap.style.setProperty('--af-top', top + 'px');
    if (gridBox) wrap.classList.toggle('af-past', gridBox.getBoundingClientRect().bottom < top + wrap.offsetHeight + 60);
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(stick); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (header) header.addEventListener('transitionend', onScroll);
  stick();

  /* Back from a product: return to the same place in a filtered list */
  window.addEventListener('pagehide', function () { if (active()) { try { sessionStorage.setItem('af-y:' + location.href, String(window.scrollY)); } catch (e) {} } });

  readUrl();
  if (active()) {
    var y = null;
    try { y = sessionStorage.getItem('af-y:' + location.href); } catch (e) {}
    if (y && 'scrollRestoration' in history) history.scrollRestoration = 'manual';
    apply(false);
    if (y) load().then(function () { window.scrollTo(0, +y); }).catch(function () {});
  } else updateUI(totalAll);
})();
